module.exports = __webpack_public_path__ + "static/media/back.af218910.svg";